import { create } from 'zustand';

interface SettingsStore {
  collaborationConfig: any;
  setCollaborationConfig: (collaborationConfig: any) => void;
}

export const useSettingsStore = create<SettingsStore>((set, get) => ({
  collaborationConfig: null,
  setCollaborationConfig: (collaborationConfig) => set({ collaborationConfig })
}));
